import React from 'react';
import classnames from 'classnames';
import Icon from 'utils/components/icon';
import DropDownLink from '../../../../../common/dropdown-link';
import { LiveBlogSorting } from '../../../state/types';

interface Props {
  sortBy: LiveBlogSorting;
  onChange: (sortBy: LiveBlogSorting) => void;
}

type SortingAttributes = {
  value: LiveBlogSorting;
  text: string;
  iconDir: 'top' | 'bottom';
};

const SORTING_MAPPER: Record<LiveBlogSorting, SortingAttributes> = {
  [LiveBlogSorting.UpdateTime]: {
    value: LiveBlogSorting.UpdateTime,
    text: 'Updated',
    iconDir: 'top'
  },
  [LiveBlogSorting.StartingTime]: {
    value: LiveBlogSorting.StartingTime,
    text: 'Starts',
    iconDir: 'top'
  },
  [LiveBlogSorting.EndingTime]: {
    value: LiveBlogSorting.EndingTime,
    text: 'Ends',
    iconDir: 'bottom'
  }
};

const SortByFilter: React.FC<Props> = ({ sortBy, onChange }) => {
  const sortingItems = Object.values(SORTING_MAPPER);
  const { text, iconDir } = SORTING_MAPPER[sortBy];

  const onSortByClick = (value: LiveBlogSorting) => {
    onChange(value);
  };

  const sortByItems = sortingItems.map(({ value, text }) => (
    <span key={value} onClick={_ => onSortByClick(value)}>
      {text}
      {value === sortBy && <Icon className={'selected-tag-icon'} name={'validation-success'} />}
    </span>
  ));

  return (
    <>
      <div className={'filter-tooltip'}>
        <DropDownLink className={'sort-dropdown'} text={text} items={sortByItems}>
          <Icon name={'sort'} className={classnames('filter-icon', iconDir)} />
        </DropDownLink>
      </div>
    </>
  );
};

export default SortByFilter;
